"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSuggestionPosition = exports.getSuggestion = void 0;
var AUTOFILL_TRIGGERS = ["hi ", "hi\xA0", 'hello ', "hello\xA0", 'dear ', "dear\xA0"];

var getSuggestion = function getSuggestion(editor, originalSuggestions, editorSelection) {
  if (!editorSelection || !editorSelection.selection) {
    return '';
  }

  var suggestion = getSuggestionValue(editor, originalSuggestions, editorSelection);
  return suggestion;
};

exports.getSuggestion = getSuggestion;

var getSuggestionPosition = function getSuggestionPosition(editor, editorSelection) {
  if (!editorSelection || !editorSelection.selection) {
    return null;
  }

  var selection = editorSelection.selection.getSel(); // Position of the suggestion tag is relative to current selection

  var coordinates = getCaretCoordinates(selection);
  if (!coordinates) return null;
  var top = coordinates.top,
      left = coordinates.left,
      width = coordinates.width;

  var _editor$getBody$getBo = editor.getBody().getBoundingClientRect(),
      maxWidth = _editor$getBody$getBo.width;

  return {
    position: 'absolute',
    top: "".concat(top, "px"),
    left: "".concat(left + width, "px"),
    width: "".concat(maxWidth, "px")
  };
};

exports.getSuggestionPosition = getSuggestionPosition;

var getSuggestionValue = function getSuggestionValue(editor, suggestions, editorSelection) {
  var firstBlock = editor.getBody().firstChild;
  var selection = editorSelection.selection,
      focusNode = editorSelection.focusNode,
      currentNode = editorSelection.currentNode,
      startElement = editorSelection.startElement;
  var blocks = editor.dom.getParents(currentNode, function (node) {
    return editor.dom.isBlock(node);
  });
  var isFirstBlock = blocks[0] === firstBlock;
  var isFirstLine = checkFirstLine(blocks[0], focusNode, startElement);
  var isCollapsed = selection.isCollapsed();
  var isEnd = isCursorAtEnd(selection.getSel());

  if (!isFirstBlock || !isFirstLine || !isCollapsed || !isEnd) {
    return '';
  } // Remove the zero-width space from Tinymce


  var text = focusNode.textContent.replace(/\ufeff/g, '').replace(/\u00A0/g, ' ');
  var suggestion = suggestions.length === 1 ? suggestions[0] : suggestions.length === 2 ? "".concat(suggestions[0], " and ").concat(suggestions[1]) : '';
  var index = 0;

  if (AUTOFILL_TRIGGERS.some(function (item) {
    index = text.slice(item.length).length;
    return text.toLowerCase().startsWith(item) && suggestion.startsWith(text.slice(item.length));
  })) {
    return suggestion.slice(index);
  }

  return '';
};
/**
    Two cases to consider: 
    1. firstChild and focusNode are both text nodes
    2. focusNode is a textNode and first child is an element,
        2.1 When the element is wrapped by bogus caret span 
        2.2 Text is formatted: Text node wrapped by HTML tag elements 
*/


var checkFirstLine = function checkFirstLine(firstBlock, focusNode, startElement) {
  var firstChild = firstBlock === null || firstBlock === void 0 ? void 0 : firstBlock.firstChild;

  if (!firstChild) {
    return false;
  }

  return firstChild === focusNode || firstChild === startElement || (firstChild === null || firstChild === void 0 ? void 0 : firstChild.firstChild) === startElement;
};

var getCaretCoordinates = function getCaretCoordinates(selection) {
  if (selection.rangeCount === 0) return null;
  var range = selection.getRangeAt(0);

  if (range.startOffset === 0) {
    range = range.cloneRange();

    try {
      range.setEnd(range.startContainer, 1);
    } catch (err) {
      console.log(err);
    }
  }

  var rect = range.getBoundingClientRect();
  return rect;
};

var isCursorAtEnd = function isCursorAtEnd(selection) {
  if (selection.rangeCount === 0) {
    return false;
  }

  var range = selection.getRangeAt(0);
  var focusOffset = selection.focusOffset,
      focusNode = selection.focusNode;

  if (focusNode.nodeType === Node.TEXT_NODE) {
    return focusOffset >= focusNode.textContent.length;
  }

  if (range.startOffset === 0) {
    range = range.cloneRange();

    try {
      range.setEnd(range.startContainer, 1);
    } catch (err) {
      console.log(err);
    }
  }

  return range.endOffset === selection.anchorOffset;
};
//# sourceMappingURL=utils.js.map